import React from 'react';
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../../component/Page/Page";
import CheckpointForm from "../CheckpointForm";

class CheckpointFormPage extends React.Component {

  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Configurações"/>,
      <BreadcrumbItem key={2} title="Lista de Ponto de Controle" to="/list/checkpoints"/>,
      <BreadcrumbItem key={3} title="Dados do ponto de controle" active={true}/>];
    return (
        <Page title="Dados do ponto de controle" breadcrumbs={breadcrumbs}>
          <CheckpointForm match={match} history={history}/>
        </Page>
    );
  }
}

export default CheckpointFormPage;



// WEBPACK FOOTER //
// ./src/checkpoint/component/CheckpointFormPage.js